document.addEventListener('DOMContentLoaded', function () {
  // The card title link stretches an invisible ::after over the whole
  // .card-wrapper (so the entire card is clickable), which sits on top of
  // the image in the paint order. That means CSS .card__media:hover can
  // never fire: the browser always hit-tests the link overlay first. So
  // mouse hover is driven here in JS, the same way touch already is, by
  // comparing the pointer position to the image's own bounding box.
  document.querySelectorAll('.card-wrapper').forEach(function (card) {
    var media = card.querySelector('.card__media');

    // Leaving the card clears the post-click suppression so the next hover
    // reveals the model shot again.
    card.addEventListener('mouseleave', function () {
      card.classList.remove('suppress-hover');
      card.classList.remove('image-hovered');
    });

    // Desktop: only reveal the model shot while the pointer is over the
    // image itself. Title, swatches, and buttons sit outside it, so hovering
    // them never swaps the image.
    card.addEventListener('mousemove', function (e) {
      if (!media) return;
      var r = media.getBoundingClientRect();
      if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
        card.classList.add('image-hovered');
      } else {
        card.classList.remove('image-hovered');
      }
    });

    // Mobile press-and-hold reveals the model shot, but only when the touch
    // lands inside the product image square. Swatches, title, and buttons sit
    // outside it, so tapping them never swaps the image.
    card.addEventListener('touchstart', function (e) {
      var t = e.touches && e.touches[0];
      if (!media || !t) return;
      var r = media.getBoundingClientRect();
      if (t.clientX >= r.left && t.clientX <= r.right && t.clientY >= r.top && t.clientY <= r.bottom) {
        card.classList.remove('suppress-hover');
        card.classList.add('image-hovered');
      }
    }, { passive: true });

    var hide = function () { card.classList.remove('image-hovered'); };
    card.addEventListener('touchend', hide);
    card.addEventListener('touchcancel', hide);
  });
});

document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.card-swatch');
  if (!swatch) return;

  e.preventDefault();
  e.stopPropagation();

  const imageId = swatch.dataset.imageId;
  const src = swatch.dataset.imageSrc;
  const srcset = swatch.dataset.imageSrcset;
  const labelId = swatch.dataset.labelId;
  const colorName = swatch.getAttribute('aria-label');
  const secondaryImageId = swatch.dataset.secondaryImageId;
  const secondarySrc = swatch.dataset.secondaryImageSrc;
  const secondarySrcset = swatch.dataset.secondaryImageSrcset;

  if (imageId && src) {
    const img = document.getElementById(imageId);
    if (img) {
      img.src = src;
      if (srcset) img.srcset = srcset;
    }
  }

  if (secondaryImageId && secondarySrc) {
    const secondaryImg = document.getElementById(secondaryImageId);
    if (secondaryImg) {
      secondaryImg.src = secondarySrc;
      if (secondarySrcset) secondaryImg.srcset = secondarySrcset;
    }
  }

  if (labelId && colorName) {
    const label = document.getElementById(labelId);
    if (label) label.textContent = colorName;
  }

  const variantId = swatch.dataset.variantId;
  if (variantId) {
    const card = swatch.closest('.card-wrapper');
    // Quick add opens on this colourway, and the card's own links land on the
    // product page with the same colourway already selected.
    if (card) {
      card.querySelectorAll('[data-base-product-url]').forEach(function (el) {
        const url = el.dataset.baseProductUrl + '?variant=' + variantId;
        if (el.tagName === 'A') {
          el.href = url;
        } else {
          el.dataset.productUrl = url;
        }
      });
    }
  }

  const container = swatch.closest('.card-swatches');
  if (container) {
    container.querySelectorAll('.card-swatch').forEach(function (s) {
      s.classList.remove('card-swatch--active');
    });
    swatch.classList.add('card-swatch--active');
  }

  // Show the just-selected colorway's back graphic even though the pointer is
  // still on the card; leaving and hovering again reveals the model shot.
  const clickedCard = swatch.closest('.card-wrapper');
  if (clickedCard) {
    clickedCard.classList.add('suppress-hover');
    clickedCard.classList.remove('image-hovered');
  }
});
